export default "__VITE_ASSET__DLuDAni7__"